import React from 'react';
import { useNavigate } from 'react-router-dom';
 
// Custom error page with professional MNC design
const ErrorPage = () => {
    const navigate = useNavigate();
 
    const handleLoginRedirect = () => {
        navigate('/'); // Replace with your login page route
    };
 
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f8f9fa', // Soft background color for professionalism
            fontFamily: 'Helvetica, Arial, sans-serif',
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                padding: '40px',
                textAlign: 'center',
                maxWidth: '600px',
                width: '90%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                {/* Logo Section */}
                <img
                    src="/AudreeLogo.png" // Path to your logo file, place it in the 'public' folder
                    alt="Company Logo"
                    style={{
                        width: '120px',
                        height: 'auto',
                        marginBottom: '30px',
                    }}
                />
               
                {/* Error Message Section */}
                <h1 style={{
                    fontSize: '2.5rem',
                    color: '#e74c3c', // A red color for the error message
                    marginBottom: '20px',
                    fontWeight: 'bold',
                }}>
                    404 - Unauthorized Access
                </h1>
                <p style={{
                    fontSize: '1.125rem',
                    color: '#7f8c8d', // Neutral color for the description
                    marginBottom: '30px',
                }}>
                    Oops! You need to log in to access this page. Please log in to continue.
                </p>
 
                {/* Login Button */}
                <button
                    onClick={handleLoginRedirect}
                    style={{
                        backgroundColor: '#3498db', // Blue color for the login button
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '14px 28px',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textDecoration: 'none',
                        transition: 'background 0.3s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2980b9'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3498db'}
                >
                    Go to Login
                </button>
            </div>
 
            {/* Footer Section */}
            <footer style={{
                marginTop: '40px',
                fontSize: '0.875rem',
                color: '#95a5a6',
            }}>
                &copy; {new Date().getFullYear()} Audree Infotech Pvt. Ltd.  All rights reserved.
            </footer>
        </div>
    );
};
 
export default ErrorPage;
 